module.exports = __webpack_public_path__ + "static/media/2500000000.480e6e0e.png";